import { Record } from 'immutable'

export class Cost extends Record({
    id: undefined,
    cost_type_id: undefined,
    date: undefined,
    repeat_id: undefined,
    date_start: undefined,
    date_end: undefined,
    price: undefined,
    currency_id: undefined,
    currency_rate: undefined,
    company_cost_center_id: undefined,
    vehicle_id: undefined,
    driver_id: undefined,
    trailer_id: undefined,
    user_id: undefined,
    person_id: undefined,
    cost_generator_id: undefined,
    supplier: undefined,
    bill_number: undefined,
    note: undefined,
}) {}
